var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cadre"},[(_vm.charge && _vm.$dossier.id)?_c('router-view',{attrs:{"compte":_vm.compte,"compte-charger":_vm.compteCharger}}):_vm._e(),(!_vm.charge)?_c('div',[_c('img',{staticClass:"loader",attrs:{"src":require("@/assets/img/courtisia-logo-inverse.svg")}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }